export default __webpack_public_path__ + "static/media/naturaldisaster.4c1207a4.svg";